module.exports = __webpack_public_path__ + "static/media/waitroseForOne.a860fb0a.csv";